import Playbook from "@/components/Playbook";

export default function AdminMonetization() {
  return (
    <Playbook
      kind="monetization"
      eyebrow="Monetization"
      headline="Eight ways this becomes a living."
      tagline="The $50/mo Skool is the front door. Here are the tiers, drops, and upsells that follow — priced and described."
      emptyCTA="Map the whole revenue stack"
    />
  );
}
